import PropTypes from 'prop-types'
import { useState } from 'react'
import { AiFillCaretDown, AiFillCaretUp } from 'react-icons/ai'
import { Link } from 'wouter'
import SubMenuItems from './SubMenuItems'

export default function MenuItems({ item, location, isSidebarOpen }) {
  // Estado para controlar el despliegue del submenú de cada ítem
  const [dropdown, setDropdown] = useState(false)

  // Estado para abrir automáticamente el submenú si coincide con la URL al cargar la página
  const [firstTimeAutoOpen, setFirstTimeAutoOpen] = useState(true)

  return (
    <>
      {/* Entramos si el menú es desplegable, si tiene submenú */}
      {item?.subMenuItems ? (
        <>
          <li className="flex" title={item?.title} key={item?.title}>
            {/* 
              Explicación de las validaciones en 'className':
                - Cuando la barra lateral está cerrada, se agrega 'whitespace-nowrap' para evitar saltos de línea en el texto.
                - Se valida si el usuario ha accedido a un ítem de un submenú (por ejemplo, 'Platano' dentro de 'Frutas'). Si es así, también se resalta el ítem principal ('Frutas').
                - El ítem del menú se resalta cuando se abre un submenú, indicando al usuario qué ítem tiene un submenú desplegable.
                - Si el ítem está activo pero no se cumplen las condiciones anteriores, se le agrega una animación de hover. 
            */}
            <Link
              id={item?.title}
              href={item?.slug}
              onClick={() => {
                setDropdown((state) => !state)
              }}
              className={`inline-flex pr-3 pl-4 py-1.5 text-base text-white duration-300 grow border-s-2 ${!isSidebarOpen && 'whitespace-nowrap'} ${
                item?.subMenuItems.some(
                  (submenu) => submenu.slug === location
                ) || dropdown
                  ? 'bg-white/20 border-white *:text-white font-semibold'
                  : item?.active &&
                    'border-transparent hover:bg-white/10 hover:border-white/50'
              }`}
            >
              <div
                className={`${isSidebarOpen ? 'w-1/6' : 'flex flex-row items-center justify-between w-6/6'}`}
              >
                {item?.icon}
                {item?.subMenuItems &&
                  !isSidebarOpen &&
                  (dropdown ? <AiFillCaretUp /> : <AiFillCaretDown />)}
              </div>

              <div
                className={`w-5/6 ml-3 flex items-center justify-between uppercase origin-left duration-75 ${!isSidebarOpen && 'scale-0'}`}
              >
                <span>{item?.title}</span>

                {item?.subMenuItems &&
                  (dropdown ? <AiFillCaretUp /> : <AiFillCaretDown />)}
              </div>
            </Link>
          </li>

          <ul
            className={`space-y-2 font-medium list-none ${!dropdown && 'hidden'}`}
          >
            {item?.subMenuItems.map((submenu, index) => {
              // Abrir el submenú automáticamente si la URL coincide con el submenú
              if (location === submenu.slug && firstTimeAutoOpen) {
                setDropdown(true)
                setFirstTimeAutoOpen(false)
              }

              return (
                <SubMenuItems
                  submenu={submenu}
                  key={submenu.slug}
                  location={location}
                  isSidebarOpen={isSidebarOpen}
                />
              )
            })}
          </ul>
        </>
      ) : (
        <>
          <li className="flex" title={item?.title} key={item?.title}>
            {/* 
              Explicación de las validaciones en 'className':
                - Cuando la barra lateral está cerrada, se agrega 'whitespace-nowrap' para evitar saltos de línea en el texto.
                - Se valida si el usuario ha accedido al ítem actual. Si es así, se resalta el ítem.
                - Si el ítem está activo pero no se cumplen las condiciones anteriores, se le agrega una animación de hover.  
            */}
            <Link
              id={item?.title}
              href={item?.slug}
              className={`inline-flex pr-3 pl-4 py-1.5 text-base text-white duration-300 grow border-s-2 ${!isSidebarOpen && 'whitespace-nowrap'} ${
                item?.slug === location
                  ? 'bg-white/20 border-white *:text-white font-semibold'
                  : item?.active &&
                    'border-transparent hover:bg-white/10 hover:border-white/50'
              }`}
            >
              <span className={`w-1/6`}>{item?.icon}</span>

              <span
                className={`w-5/6 ml-3 origin-left duration-75 uppercase ${!isSidebarOpen && 'scale-0'}`}
              >
                {item?.title}
              </span>
            </Link>
          </li>
        </>
      )}
    </>
  )
}

// Define los tipos de las props que recibe el componente actual
MenuItems.propTypes = {
  item: PropTypes.object,
  user: PropTypes.object,
  location: PropTypes.string,
  isSidebarOpen: PropTypes.any
}
